export const all_routes = {
  home: '/',

  // Blog Routes
  blogGrid: '/blog/blog-grid',
  blogGridSidebarRight: '/blog/blog-grid-sidebar-right',
  blogGridSidebarLeft: '/blog/blog-grid-sidebar-left',
  blogList: '/blog/blog-list',
  blogListSidebarRight: '/blog/blog-list-sidebar-right',
  blogListSidebarLeft: '/blog/blog-list-sidebar-left',
  blogCarousel: '/blog/blog-carousel',
  blogDetails: '/blog/blog-details',
  blogDetailsSidebarRight: '/blog/blog-details-sidebar-right',
  blogDetailsSidebarLeft: '/blog/blog-details-sidebar-left',

  // Pages Routes
  aboutUs: '/about-us',
  comingSoon: '/coming-soon',
  error404: '/error-404',
  events: '/events',
  eventDetails: '/events/event-detail/:id',
  services: '/services',
  serviceDetail: '/services/service-detail/:id',
  instructorDetail: '/instructors/instructor-detail/:id',
  instructors: '/instructors',
  featureDetail: '/features/feature-detail/:id',
  features: '/features',
  termsCondition: '/terms-condition',
  testimonials: '/testimonials',
  testimonialsCarousel: '/testimonials-carousel',
  maintenance: '/maintenance',
  privacyPolicy: '/privacy-policy',
  pricing: '/pricing',
  pricingDetail: '/pricing/pricing-detail/:id',
  ourTeams: '/our-teams',
  myProfile: '/my-profile',
  faq: '/faq',
  gallery: '/gallery',
  invoice: '/coaches/invoice',
  lessonOrderConfirm: '/coaches/lesson-order-confirm',
  lessonPayment: 'coaches/lesson-payment',
  lessonPersonalInfo: 'coaches/lesson-personal-info',
  userWallet: '/user/user-wallet',

  // Coaches Routes
  bookingCancelled: '/coaches/booking-cancelled',
  bookingCompleted: '/coaches/booking-completed',
  allCourt: '/coaches/all-court',
  appointmentDetails: '/coaches/appointment-details',
  addCourt: '/coaches/add-court',
  activeCourt: '/coaches/active-court',
  inactiveCourt: '/coaches/inactive-court',
  coachDetail: '/coaches/coach-detail',
  coachDetails: '/coaches/coach-details',
  coachEarning: '/coaches/coach-earning',
  coachesGrid: '/coaches/coaches-grid',
  coachesGridSidebar: '/coaches/coaches-sidebar-grid',
  coachesList: '/coaches/coaches-list',
  coachesListSidebar: '/coaches/coaches-sidebar-list',
  coachesMap: '/coaches/coaches-map',
  coachRequest: '/coaches/coach-request',
  coachWallet: '/coaches/coach-wallet',
  coachTimeDate: '/coaches/coach-time-date',
  coachProfile: '/coaches/coach-profile',
  coachPersonalInfo: '/coaches/coach-personal-info',
  coachPayment: '/coaches/coach-payment',
  coachOrderConfirm: '/coaches/coach-order-confirm',
  coachesMapSidebar: '/coaches/coaches-map-sidebar',
  earningCoaching: '/coaches/earning-coaching',
  cageCheckout: '/coaches/cage-checkout',
  cageDetails: '/coaches/cage-details',
  cageOrderConfirm: '/coaches/cage-order-confirm',
  cagePersonalInfo: '/coaches/cage-personal-info',
  lessonTimeDate: '/coaches/lesson-time-date',
  lessonType: '/coaches/lesson-type',
  settingLesson: '/coaches/setting-lesson',
  settingPassword: '/coaches/setting-password',
  settingAvailability: '/coaches/setting-availability',
  profileOtherSetting: '/coaches/user-profile-other-setting',
  coachDashboard: '/coaches/coach-dashboard',
  coachBooking: '/coaches/coach-booking',
  coachChat: '/coaches/coach-chat',
  venueDetails: '/coaches/venue-details',

  // User Routes
  userComplete: '/user/user-complete',
  userDashboardProfiles: '/user/user-dashboard-profiles',
  userDashboard: '/user/user-dashboard',
  userInvoice: '/user/user-invoice',
  userBookings: '/user/user-bookings',
  userChat: '/user/user-chat',
  userCoaches: '/user/user-coaches',
  userProfile: '/user/user-profile',
  userSettingPassword: '/user/user-setting-password',
  userProfileOtherSetting: '/user/user-profile-other-setting',
  userCancelled: '/user/user-cancelled',
  userOngoing: '/user/user-ongoing',

  // Listing Routes
  listingGridSidebar: '/listing/listing-grid-sidebar',
  listingGrid: '/listing/listing-grid',
  listingListSidebar: '/listing/listing-list-sidebar',
  listingList: '/listing/listing-list',
  listingMapSidebar: '/listing/listing-map-sidebar',
  listingMap: '/listing/listing-map',

  // Auth Routes
  register: '/auth/register',
  login: '/auth/login',
  changePassword: '/auth/change-password',
  forgotPassword: '/auth/forgot-password',

  //contact-us
  contactUs: '/contact-us',

  // Dashboard
  dashboard: '/dashboard',

  users: '/dashboard/users',
  addUser: '/dashboard/users/add',
  editUser: '/dashboard/users/edit/:id',
  showUser: '/dashboard/users/show/:id',

  products: '/dashboard/products',
  addProduct: '/dashboard/products/add',
  editProduct: '/dashboard/products/edit/:id',
  showProduct: '/dashboard/products/show/:id',

  productCategories: '/dashboard/product-categories',
  addProductCategory: '/dashboard/product-categories/add',
  editProductCategory: '/dashboard/product-categories/edit/:id',
  showProductCategory: '/dashboard/product-categories/show/:id',

  sales: '/dashboard/sales',
  addSale: '/dashboard/sales/add',
  editSale: '/dashboard/sales/edit/:id',
  showSale: '/dashboard/sales/show/:id',

  contacts: '/dashboard/contacts',

  fees: '/dashboard/fees',
  addFee: '/dashboard/fees/add',
  editFee: '/dashboard/fees/edit/:id',
  showFee: '/dashboard/fees/show/:id',

  dashboardServices: '/dashboard/services',
  addService: '/dashboard/services/add',
  editService: '/dashboard/services/edit/:id',

  dashboardInstructors: '/dashboard/instructors',
  addInstructor: '/dashboard/instructors/add',
  editInstructor: '/dashboard/instructors/edit/:id',

  dashboardFeatures: '/dashboard/features',
  addFeature: '/dashboard/features/add',
  editFeature: '/dashboard/features/edit/:id',

  dashboardTestimonials: '/dashboard/testimonials',
  addTestimonial: '/dashboard/testimonials/add',
  editTestimonial: '/dashboard/testimonials/edit/:id',

  prices: '/dashboard/prices',
  addPrice: '/dashboard/prices/add',
  editPrice: '/dashboard/prices/edit/:id',

  dashboardEvents: '/dashboard/events',
  addEvent: '/dashboard/events/add',
  editEvent: '/dashboard/events/edit/:id',

  dashboardGallery: '/dashboard/gallery',
  addGallery: '/dashboard/gallery/add',
  editGallery: '/dashboard/gallery/edit/:id',
};
